<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <button class="mr-0 mr-sm-16" mat-icon-button [routerLink]="'/pages/settings/spaces'">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <mat-icon class="logo-icon mr-16" *fuseIfOnDom
        [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">list</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom
        [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'main.spaces' | translate}}</span>
      </div>

      <div>
        <button mat-raised-button
          class="add-product-button mat-white-bg my-12 mt-sm-0"
          (click)="addSpace()">
          <span>{{'main.add' | translate}}</span>
        </button>
      </div>
    </div>


    <!-- / HEADER -->
    <!-- CONTENT CARD -->

    <div class="content-card mat-white-bg" style="justify-content: normal" >
      @if (platforms && platforms.length) {
        <div>
          <mat-form-field>
            <mat-select [(ngModel)]="platformId" placeholder="{{'event.platforms' | translate}}" required>
              @for (plat of platforms; track plat.id) {
                <mat-option [value]="plat.id">
                  {{plat.title}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      <div >
        <mat-form-field>
          <mat-label>{{'space_name' | translate}}</mat-label>
          <input matInput placeholder="{{'enter_name' | translate}}" [(ngModel)]="name" required>
        </mat-form-field>
      </div>
      <div class="subcats">
        <div style="font-size: 18px; color: rgba(0,0,0,0.8);margin-bottom: 10px">{{'boards' | translate}}</div>
        @for (sc of spaceBoard; track sc) {
          <div class="sub-cat">
            <mat-form-field>
              <mat-label>{{'board_name' | translate}}</mat-label>
              <input matInput placeholder="{{'enter_board' | translate}}" id="{{sc.spbId}}_subcat"
                [value]="sc.name ? sc.name : ''" required>
              </mat-form-field>
              <mat-icon class="remove-el" (click)="removeSpaceBoard(sc.spbId)">remove</mat-icon>
            </div>
          }
          <div class="add-subcat" (click)="addSpaceBoard()">{{'add_board' | translate}}</div>
        </div>
      </div>

      <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
  </div>
